import styled, { css } from "styled-components";

export const ButtonMoreActions = styled.button`
  padding: 5px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
  border-radius: 5px;
  margin-left: 6px;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
  }
`

export const Container = styled.div`
  width: 150px;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.surface.surface};
`

export const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 6px;
  gap: 2px;
`

interface ICardItemProps {
  isdelete?: boolean;
}

export const CardItem = styled.div<ICardItemProps>`
  width: 100%;
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 6px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.surface.surface};
  cursor: pointer;

  .cardItemIcon {
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
  }

  .cardItemText {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    margin-left: 6px;
  }

  &:hover {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }

  ${({ isdelete, theme }) => isdelete && css`
    
    &:hover {
      background-color: ${`color-mix(in srgb, ${theme.colors.danger.dangerHover}, ${theme.colors.surface.surface})`};
      
      .cardItemIcon {
        color: ${theme.colors.danger.danger} !important;
      }
    }
  `}
`

export const Hr = styled.hr`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  margin: 1.5px 0;
`
